import React,{useEffect,useState} from 'react';
import { Grid,Box,Typography} from '@mui/material';
import TOKCart from '../TOKCart/TOKCart';


const TOCart = (props:any) => {
    let{objj,num,namee}=props  || {};
    let{name,verticalKeyResultTeamsObjectiveKeyResult}=objj  || {};
    const[allKrs,setAllKRs]=useState<any[]>();
    useEffect(() => {
        setAllKRs(verticalKeyResultTeamsObjectiveKeyResult)
    }, [verticalKeyResultTeamsObjectiveKeyResult])

  return (  
    
    // <Grid container boxShadow={4} bgcolor={'#a0b8ff'} borderRadius={4} p={2} >
    <Grid container boxShadow={4} bgcolor={'#00387C'} borderRadius={4} p={2} >
        <Grid item xs={12}  >
        <Grid container >
        <Grid item xs={12}  >
        <Box 
        display={'flex'} 
        width={'100%'}
        alignItems={'start'}
        flexDirection={'column'}
        minHeight={'90px'} 
        justifyContent={'center'}  > 
        <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
        {
          namee === "WithOut" ?
          <Typography  variant='body1' fontWeight={900} color={'#fff'}  fontSize={'15px'} >
             نتیجه {num + 1} :{name}
        </Typography> :
          <Typography  variant='body1' fontWeight={900}  color={'#fff'} fontSize={'15px'} >
           هدف {num + 1} :{name}
         </Typography>
        }
        </Box>
        </Box>
        </Grid>
      </Grid>
        </Grid>
        <Grid item xs={12}  >
         {
          allKrs !== null && allKrs !== undefined && allKrs.length>0 &&  <Grid container  >
          <Grid item xs={12}  >
            <Grid container spacing={1} px={1} >
           {
            allKrs && allKrs.map((o:any,i:number)=>{
              return <Grid  item xs={12} sm={6}  >
                <Box width={'100%'} key={i}   >
                <TOKCart kr={o}   
                item={o}
                num = {i}
                />
              </Box>
              </Grid>
            })
          }
           </Grid> 
          </Grid>
         </Grid>
         }
        </Grid>
    </Grid>
  )
}

export default TOCart